import "./Home.css";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";

function Planung() {

return (
    <div className="hero-container">
      <Container className="py-3">
        {/* Hero Section */}
        <Row className="align-items-center py-5">
          <Col xs={12} md={6} className="text-center text-md-start">
            <h1 className="fs-1 text-white">
            Planung und Beratung
            </h1>
            <p className="text-break text-wrap mt-4 text-white fs-6 fs-md-5 fs-lg-4">
            Sie haben bereits erste Ideen und Vorstellungen für Ihren Garen oder auch nicht? Mit unserer langjährigen Erfahrung und unserem Fachwissen beraten wir Sie gerne und planen gemeinsam mit Ihnen Ihr individuelles Gartenprojekt.
            Alles aus einer Hand auch während der umsetzung können wir die Planung wieder aufgreifen und anpassen. 
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-center mt-4 mt-md-0"
          >
            <Carousel>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />;
                <Carousel.Caption>
                  <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />;
                <Carousel.Caption>
                  <h3>Second slide label</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />;
                <Carousel.Caption>
                  <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>

        <Row className="align-items-center py-5">
          {/* Text soll auf kleinen Bildschirmen unten erscheinen */}
          <Col
            xs={{ span: 12, order: 1 }}
            md={{ span: 6, order: 2}}
            className="text-center text-md-start"
          >
            <p className="text-break text-wrap mt-4 text-white fs-6 fs-md-5 fs-lg-4">
              Je nach Größe und Umfang eine Projektes ist Auch die Planung Komplex. Ein transparenter so wie Kompetenter Partner ist ein muss. 
              Kontaktieren Sie uns gerne unverbindlich. In einem ersten
              Telefonat besprechen wir Ihr Vorhaben und vereinbaren einen Termin
              vor Ort. Wir freuen uns auf Sie.
            </p>
            <Button
              as={Link}
              to="/kontakt"
              variant="outline-light"
              className="btn-lg"
            >
              Kontakt
            </Button>
          </Col>

          {/* Carousel soll auf kleinen Bildschirmen oben erscheinen */}
          <Col
            xs={{ span: 12, order: 2 }}
            md={{ span: 6, order: 1 }}
            className="d-flex justify-content-center mt-4 mt-md-0"
          >
            <Carousel>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />
                <Carousel.Caption>
                  <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />
                <Carousel.Caption>
                  <h3>Second slide label</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />
                <Carousel.Caption>
                  <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
}


export default Planung;
